import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import preventReClick from '../static/js/preventRepeatClick.js'
Vue.use(preventReClick)

import Rsa from "./common/js/rsa.js"
Vue.prototype.$Rsa = Rsa // 将Rsa注册为公共方法,方便其他页面调用

import './common/js/dialog.js'
Vue.use(Element)
// 引入echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
import DrawEchars from './common/js/drawCharts.js'
Vue.prototype.$drawEchars = DrawEchars

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import regularCheck from "./utils/regular.js"
Vue.prototype.$regularCheck = regularCheck.regularCheck
//引入轮播
import 'swiper/dist/css/swiper.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

function formatDate(date, fmt) {
  if (date == "") {
    return fmt = ""
  } else {
    date = new Date(date);
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + ''
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
      }
    }
    return fmt
  }

};

//定义一个时间过滤器
Vue.filter("FormatDate", function(date, fmt) {
  return formatDate(date, fmt);
});

new Vue({
  el: '#app',
  router, //将router实例传递给vue实例
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js